module.exports = __webpack_public_path__ + "6be12248ff15f5653d80fbe6b27cd59e.MP3";